import React, { useState, useEffect } from 'react'
import LogoImage from "../../assets/img/logo.svg";
import exclamationMark from "../../assets/icons/ic-exclamation-mark.svg";
import {ReactComponent as IconCheckBlue} from '../../assets/icons/ic-check-blue.svg'
import router from '../../router'
import Toast from "../../plugins/useToast";
import { useRecoilState } from "recoil";
import { audioPlayState,demoModeState } from '../../plugins/recoil';
import axios from '../../plugins/axios'
import { useTranslation } from 'react-i18next';

const Login = () => {
    const { t, i18n } = useTranslation()
    const [isSecure, setIsSecure] = useState(true)
    const [id, setId] = useState('')
    const [pass, setPass] = useState('')
    const [, setPlayAudio] = useRecoilState(audioPlayState);
    const [, setIsDemoActive] = useRecoilState(demoModeState);
    const downloadUrl = process.env.REACT_APP_AUDIO_MANAGE_DOWNLOAD_URL

    const handleDownload = async () => {
        try {
            const response = await fetch(downloadUrl);
            if (!response.ok) throw new Error('Network response was not ok.');
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            // 파일 이름을 URL에서 추출하거나 기본값을 설정합니다.
            const filename = downloadUrl.substring(downloadUrl.lastIndexOf('/') + 1) || 'audio_program';
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download failed:', error);
            Toast({ isSuccess: false, msg: t(`login.unknownError`) });
        }
    };

    const handleLogin = async () => {
        if (!id || !pass) return
        try {
            const res = await axios.post('/auth/login', { loginId: id, password: pass })
            if (res.code != '200') throw res
            localStorage.setItem('loginId', id)
            localStorage.setItem('cmsUserId', res.data.cmsUserId)
            localStorage.setItem('accessToken', res.data.token)
            localStorage.setItem('refreshToken', res.data.refreshToken)

            setIsDemoActive(false);
            localStorage.setItem('demoMode', false)

            const userRes = await axios.get('/user/me')
            if (userRes.code != '200') throw userRes
            if (userRes?.data?.language) {
                i18n.changeLanguage(userRes.data.language)
                localStorage.setItem('lang', userRes.data.language)
            }
            if (res.data.passwordChangeRequired) {
                router.navigate('/resetPassword')
            } else {
                router.navigate('/dashboard')
            }            
            
            if(!res.data.isDemoMode){
                await axios.post('/demo/start') 
                setIsDemoActive(true);
                localStorage.setItem('demoMode', true)
            }

            setPlayAudio(true);
        } catch (err) {
            if (err.code == 2003) {
                Toast({ isSuccess: false, msg: t(`login.wrongAccount`) });
            } else if (err.code == 2005) {
                Toast({ isSuccess: false, msg: t(`login.userInactive`) });
            } else {
                Toast({ isSuccess: false, msg: t(`login.unknownError`) });
            }
        }
    }

    const handleEnter = (e) => {
        if (e.keyCode === 13) {
            handleLogin()
        }
    }

    useEffect(() => {
        const hasServerError = localStorage.getItem("serverError");
        if (hasServerError == "SERVER") {
            Toast({ isSuccess: false, msg: t(`login.serverError`) });
            localStorage.removeItem('serverError')
        } else if (hasServerError == 'SESSION') {
            Toast({ isSuccess: false, msg: t(`login.sessionExpired`) });
            localStorage.removeItem('serverError')
        } else if (hasServerError) {
            Toast({ isSuccess: false, msg: t(`login.unknownError`) });
            localStorage.removeItem('serverError')
        }

        const lang = localStorage.getItem('lang')
        if (lang) {
            i18n.changeLanguage(lang)
        } else {
            i18n.changeLanguage('en')
        }
    }, [])

    return (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-[9999]">
            <div
                className="fixed inset-0 bg-[#113577] flex items-center justify-center z-50"
                style={{
                    // backgroundImage: `url(${backgroundImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}
            >
                <div
                    className="w-[1080px] h-[96px] absolute top-[260px] left-1/2 ml-[-540px]"
                    style={{
                    backgroundImage: `url(${LogoImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    }}
                />
                <div className="absolute top-[440px] w-[512px] flex flex-col">
                    <div className="" style={{ backgroundColor: 'white', padding: '14px 23px', borderRadius: 8, border: '1px solid #CECECE' }}>
                        <input className='w-full' type="text" value={id} onChange={(e) => setId(e.target.value)} onKeyDown={handleEnter} placeholder={t('login.id')} style={{ backgroundColor: 'transparent', outline: 'none', border: 'none' }}/>
                    </div>
                    <div className="mt-2" style={{ backgroundColor: 'white', padding: '14px 23px', borderRadius: 8, border: '1px solid #CECECE' }}>
                        <div className="flex relative">
                            <input className='' type={isSecure ? 'password' : 'text'} value={pass} onKeyDown={handleEnter} onChange={(e) => setPass(e.target.value)} placeholder={t('login.password')} style={{ backgroundColor: 'transparent', borderColor: '#c3c3c3', outline: 'none', width: '100%', paddingRight: 25 }}/>
                            {/* <Icon className='absolute right-0 cursor-pointer' style={{color: '#c3c3c3'}} onClick={() => { setIsSecure(!isSecure) }} path={isSecure ? mdiEyeOutline : mdiEyeOffOutline} size={1} /> */}
                        </div>
                    </div>
                    <button
                        disabled={!id || !pass}
                        onClick={handleLogin}
                        className="w-[512px] h-[60px] bg-gradient-to-b from-[#3182F7] to-[#1562D1] text-white font-light text-[20px] rounded-[4px] transition mt-[32px]"
                        style={{ opacity: id && pass ? 1 : 0.4 }}
                    >
                        { t('login.login') }
                    </button>
                    <div className='flex flex-col w-full border border-black mt-[48px] px-[20px] py-[24px] bg-[#0D2756] rounded-[8px] gap-[6px]'>
                         <div className='relative flex items-start gap-[8px]'>
                            <img src={exclamationMark} alt="exclamation mark" className='pt-[2px]'/>
                            <div className='flex flex-col gap-[6px]'>
                                <p className='text-[#E1E4E5] font-pretendard text-[24px] font-medium leading-[120%]'>{ t('login.noticeContent1') }</p>                                
                            </div>                            
                         </div>
                         <p className='text-[#B5B8BD] font-pretendard text-[16px] font-normal leading-[120%] pl-[32px]'>{ t('login.noticeContent2') }</p>                         
                         <div className='w-full h-[1px] border border-[#1F1F1F] shadow-[ -1px_0_0_0_rgba(0,0,0,0.40) ] my-[16px]'></div>
                         <div className='flex flex-col px-[32px] gap-[12px]'>
                            <div className='flex gap-[8px]'>
                               <IconCheckBlue />
                               <span className='text-[#ABAEB2] font-pretendard text-[16px] font-bold leading-[18px]'>{ t('login.noticeContent3') }</span>
                            </div>
                            <div className='flex gap-[8px]'>
                               <IconCheckBlue />
                               <span className='text-[#ABAEB2] font-pretendard text-[16px] font-bold leading-[18px]'>{ t('login.noticeContent4') }</span>
                            </div>
                            <div className='flex gap-[8px]'>
                               <IconCheckBlue />
                               <span className='text-[#ABAEB2] font-pretendard text-[16px] font-bold leading-[18px]'>{ t('login.noticeContent5') }</span>
                            </div>
                         </div>
                    </div>
                    
                </div>
                {
                    /Windows/.test(navigator.userAgent) &&
                    <span onClick={handleDownload} className="absolute bottom-8 right-8 text-white cursor-pointer" style={{ fontWeight: 500, textDecoration: 'underline' }}>{t('audioModal.download')}</span>
                }
            </div>
        </div>
    )
}

export default Login